<div class="{{ sectionclass }}">
	<div class="card card-long">
		<div class="" *ngIf="showStats">
			<div class="" *ngIf="creative">
				<div *ngIf="creative?.isTelevision" class="creative_name">{{ creative.creativeName }}</div>
				<ul *ngIf="isDOOH" class="creative-stats">
					<li>
						<span class="stats">{{ creative.impressions | number }}</span>
						<span class="stats-label">Impressions</span>
					</li>
				</ul>
				<ul *ngIf="!isDOOH" class="creative-stats">
					<li *ngIf="!creative?.isTelevision">
						<span class="stats">{{ creative.impressions | number }}</span>
						<span class="stats-label">Impressions</span>
					</li>
					<li
						*ngIf="
							!creative?.isVideoCreative &&
							!creative?.adHeadline &&
							!creative?.iframeUrl &&
							creative?.isIAB &&
							!creative?.isTelevision &&
							!creative?.isAudioCreative
						"
						class="ad-interactions"
					>
						<span class="stats">{{ creative.adInteractions | number }}</span>
						<span class="stats-label">Ad Interactions</span>
					</li>
					<li
						*ngIf="
							!creative?.isVideoCreative &&
							!creative?.adHeadline &&
							!creative?.iframeUrl &&
							creative?.isIAB &&
							!creative?.isTelevision &&
							!creative?.isAudioCreative
						"
						class="ad-interactions-rate"
					>
						<span class="stats">{{ creative?.adInteractionRate | number : '0.1-2' }}%</span>
						<span class="stats-label">Ad Interaction Rate</span>
					</li>
					<li *ngIf="(creative.isVideoCreative || creative.isAudioCreative) && !creative?.isTelevision">
						<span class="stats">{{ creative?.completions | number }}</span>
						<span class="stats-label">Completions</span>
					</li>
					<li *ngIf="(creative.isVideoCreative || creative.isAudioCreative) && !creative?.isTelevision">
						<span class="stats">{{ creative?.completionRate | number : '0.2-2' }}%</span>
						<span class="stats-label">Completion Rate</span>
					</li>
					<li *ngIf="!creative?.isCtv && !creative?.isTelevision && !creative?.isAudioCreative">
						<span class="stats">{{ creative.clicks | number }}</span>
						<span class="stats-label">Clicks</span>
					</li>
					<li
						*ngIf="
							!creative?.isCtv && creative?.clickRate >= 0 && !creative?.isTelevision && !creative?.isAudioCreative
						"
					>
						<span class="stats">{{ creative.clickRate | number : '0.1-2' }}%</span>
						<span class="stats-label">Click Rate</span>
					</li>
					<li *ngIf="creative?.clickthroughrate && !creative?.isTelevision && !creative?.isAudioCreative">
						<span class="stats">{{ creative.clickthroughrate | number : '0.1-2' }}%</span>
						<span class="stats-label">Click Rate</span>
					</li>
					<li
						*ngIf="
							creative?.absTopImpression &&
							(dateRange === 'WITHIN' || dateRange === 'BEFORE') &&
							!creative?.isTelevision &&
							!creative?.isAudioCreative
						"
					>
						<span class="stats">{{ creative.absTopImpression | number }}%</span>
						<span class="stats-label">Absolute Top Impression</span>
					</li>
					<li
						*ngIf="
							creative?.avgPosition &&
							(dateRange === 'AFTER' || dateRange === 'WITHIN') &&
							!creative?.isTelevision &&
							!creative?.isAudioCreative
						"
					>
						<span class="stats">{{ creative.avgPosition | number }}</span>
						<span class="stats-label">Avg. Position</span>
					</li>
					<li
						*ngIf="
							!creative?.isAudioCreative &&
							creative?.isTelevision &&
							(partnerName === 'Midco' || allowTelevisionCreative)
						"
						class="Exposures_width"
					>
						<span class="stats">{{ creative.exposures | number }}</span>
						<span class="stats-label">Exposures</span>
					</li>
					<li
						*ngIf="
							!creative?.isAudioCreative &&
							creative?.isTelevision &&
							(partnerName === 'Midco' || allowTelevisionCreative)
						"
					>
						<span class="stats">{{ creative.zones | number }}</span>
						<span class="stats-label">Zones</span>
					</li>
				</ul>
			</div>
		</div>

		<div class="card-long-bg" style="width: 100%" [ngStyle]="{ 'padding-top': creative.adHeadline ? '0' : '0px' }">
			<div
				*ngIf="
					!creative.isVideoCreative && !creative.adHeadline && !creative?.isTelevision && !creative?.isAudioCreative
				"
				class="creative-thumbnail"
			>
				<div class="card-long-img">
					<img
						[src]="creative?.creativeThumbnail"
						*ngIf="
							(creative?.creativeThumbnail && creative.isSocial && creative.isIframeExpired === 0) ||
							(!creative.isSocial && creative?.creativeThumbnail)
						"
						(click)="openModal()"
						width="320"
						[ngClass]="{
							c300x600: creative.creativeThumbnail.includes('300x600'),
							c728x90: creative.creativeThumbnail.includes('728x90'),
							c160x600: creative.creativeThumbnail.includes('160x600'),
							c320x50: creative.creativeThumbnail.includes('320x50') || creative.creativeThumbnail.includes('300x50'),
							c468x60: creative.creativeThumbnail.includes('468x60'),
							c300x250: creative?.creativeThumbnail?.includes('300x250')
						}"
					/>
					<img
						[src]="creative?.snapshotImage"
						*ngIf="
							creative?.snapshotImage &&
							creative?.snapshotImage !== 'null' &&
							creative.isSocial &&
							creative.isIframeExpired === 1
						"
						class="card-long-img"
						(click)="openModal()"
						[ngClass]="{
							c300x600: creative?.creativeThumbnail?.includes('300x600'),
							c728x90: creative?.creativeThumbnail?.includes('728x90'),
							c160x600: creative?.creativeThumbnail.includes('160x600'),
							c320x50:
								creative?.creativeThumbnail?.includes('320x50') || creative?.creativeThumbnail?.includes('300x50'),
							c468x60: creative?.creativeThumbnail?.includes('468x60'),
							c300x250: creative?.creativeThumbnail?.includes('300x250')
						}"
					/>

					<div
						*ngIf="
							(!creative?.snapshotImage || creative?.snapshotImage === 'null') &&
							creative.isSocial &&
							creative.isIframeExpired === 1
						"
						class="card-long-img"
					>
						<div
							*ngIf="creative?.creativeThumbnail"
							class="card-long-img"
							[ngStyle]="{
								background: 'url(../../../../../../assets/images/no-creative-preview-r2.png) no-repeat center center',
								'background-size': getCreativeSize(creative?.creativeThumbnail)
							}"
						></div>
						<div style="clear: both"></div>
					</div>
				</div>
				<div class="badge-display">
					<p class="pills" *ngIf="creative?.isIAB">IAB Display</p>
					<p class="pills" *ngIf="creative?.isNative">Native</p>
				</div>
			</div>
			<div
				*ngIf="
					creative?.isTelevision &&
					!creative.isVideoCreative &&
					(partnerName === 'Midco' || allowTelevisionCreative) &&
					!creative?.isAudioCreative
				"
			>
				<div class="no_video_creative">
					<app-video-player [videoURL]="" style="visibility: hidden; position: absolute"></app-video-player>
					<span style="margin: auto">Video Unavailable</span>
				</div>
			</div>
			<div *ngIf="creative.isVideoCreative && !creative?.isAudioCreative" class="creative-video">
				<app-video-player
					[videoURL]="creative.creativeVideo"
					*ngIf="creative.creativeVideo && !isOverviewPrerollGAM"
				></app-video-player>
				<app-video-player [videoURL]="creative.mp4" *ngIf="creative.mp4 && isOverviewPrerollGAM"></app-video-player>
				<div *ngIf="(!creative.mp4 && isOverviewPrerollGAM) || !creative.creativeVideo" class="creative-thumbnail">
					<div class="card-long-img">
						<img
							[src]="creative?.creativeThumbnail"
							*ngIf="creative?.creativeThumbnail && creative.isSocial && creative.isIframeExpired === 0"
							(click)="openModal()"
							width="320"
							[ngClass]="{
								c300x600: creative.creativeThumbnail.includes('300x600'),
								c728x90: creative.creativeThumbnail.includes('728x90'),
								c160x600: creative.creativeThumbnail.includes('160x600'),
								c320x50: creative.creativeThumbnail.includes('320x50') || creative.creativeThumbnail.includes('300x50'),
								c468x60: creative.creativeThumbnail.includes('468x60'),
								c300x250: creative?.creativeThumbnail?.includes('300x250')
							}"
						/>
						<img
							[src]="creative?.snapshotImage"
							*ngIf="
								creative?.snapshotImage &&
								creative?.snapshotImage !== 'null' &&
								creative.isSocial &&
								creative.isIframeExpired === 1
							"
							class="card-long-img"
							(click)="openModal()"
							[ngClass]="{
								c300x600: creative?.creativeThumbnail?.includes('300x600'),
								c728x90: creative?.creativeThumbnail?.includes('728x90'),
								c160x600: creative?.creativeThumbnail.includes('160x600'),
								c320x50:
									creative?.creativeThumbnail?.includes('320x50') || creative?.creativeThumbnail?.includes('300x50'),
								c468x60: creative?.creativeThumbnail?.includes('468x60'),
								c300x250: creative?.creativeThumbnail?.includes('300x250')
							}"
						/>
						<div
							*ngIf="
								(!creative?.snapshotImage || creative?.snapshotImage === 'null') &&
								creative.isSocial &&
								creative.isIframeExpired === 1
							"
							class="card-long-img"
						>
							<div
								*ngIf="creative?.creativeThumbnail"
								class="card-long-img"
								[ngStyle]="{
									background: 'url(../../../../../../assets/images/no-creative-preview-r2.png) no-repeat center center',
									'background-size': getCreativeSize(creative?.creativeThumbnail)
								}"
							></div>
							<div style="clear: both"></div>
						</div>
						<div *ngIf="isOverviewPrerollGAM" class="card-long-img">
							<img
								[src]="creative?.creativeThumbnail"
								width="320"
								[ngClass]="{
									c300x600: creative.creativeThumbnail.includes('300x600'),
									c728x90: creative.creativeThumbnail.includes('728x90'),
									c160x600: creative.creativeThumbnail.includes('160x600'),
									c320x50:
										creative.creativeThumbnail.includes('320x50') || creative.creativeThumbnail.includes('300x50'),
									c468x60: creative.creativeThumbnail.includes('468x60'),
									c300x250: creative?.creativeThumbnail?.includes('300x250')
								}"
							/>
						</div>
					</div>
					<div class="badge-display">
						<p class="pills" *ngIf="creative?.isIAB">IAB Display</p>
						<p class="pills" *ngIf="creative?.isNative">Native</p>
					</div>
				</div>
			</div>
			<div *ngIf="creative?.isTelevision && (partnerName === 'Midco' || allowTelevisionCreative)" class="top_networks">
				Top Networks
			</div>
			<div
				*ngIf="
					creative?.isTelevision &&
					(partnerName === 'Midco' || allowTelevisionCreative) &&
					creative.networkData?.length > 0
				"
				class="top5_network_logos"
			>
				<div *ngFor="let network of creative.networkData" class="network_logo_container">
					<div *ngIf="network.logo !== ''" style="display: flex">
						<img class="network_logo" [src]="network.logo" />
					</div>
					<div class="network-logo-div" *ngIf="network.logo === ''">
						<span class="network-logo-name" style="font-size: 1.3vw; font-weight: bold">
							<span id="networkLogo" style="margin: auto; overflow: hidden; max-height: 100%; font-size: 25px">
								{{ network.marphedlogo }}</span
							>
						</span>
					</div>
					<div class="network_name">{{ network.name }}</div>
				</div>
			</div>
			<div
				*ngIf="
					!(creative.networkData?.length > 0) &&
					creative?.isTelevision &&
					(partnerName === 'Midco' || allowTelevisionCreative)
				"
				style="padding-top: 2rem"
			>
				No Network Data Available
			</div>
			<div
				class="analytics-portlet-content sem-creative-card-container sem-creative-performance-card"
				*ngIf="creative.adHeadline"
			>
				<div>
					<div class="sem-creative-card" style="width: 85%">
						<div class="sem-creative-card" style="width: 100%">
							<h4 class="sem-creative-heading">{{ creative.adHeadline }}</h4>
							<div class="sem-creative-card-link-container">
								<span class="sem-creative-card-text">AD</span>
								<cite class="sem-creative-card-link">{{ creative.url }}</cite>
							</div>
							<span class="sem-creative-card-roboto"> {{ creative.callExtension }}</span>
							<div
								*ngIf="isTypeString(creative?.description); else elseBlock"
								class="sem-creative-card-description sem-creative-card-roboto"
							>
								{{ creative?.description }}
							</div>
							<ng-template #elseBlock>
								<div class="sem-creative-card-description sem-creative-card-roboto">
									<p *ngFor="let desc of creative?.description">
										{{ desc }}
									</p>
								</div>
							</ng-template>

							<div class="sem-creative-card-callouts-container sem-creative-card-roboto">
								<div>
									<p>
										<span *ngFor="let callout of creative?.calloutsExtn; let i = index"
											>{{ callout
											}}<span [ngClass]="{ last_callout_class: i == creative?.calloutsExtn.length - 1 }">
												&middot;
											</span></span
										>
									</p>
								</div>
							</div>
							<div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
								<div *ngFor="let snippet of creative?.structuredSnippetExtn">
									<p>{{ snippet?.type }}: {{ snippet?.value }}</p>
								</div>
							</div>
							<div class="sem-creative-card-siteLinks-container">
								<div *ngFor="let siteLink of creative.siteLinks" class="sem-creative-card-sitelinks">
									<h4>
										<a href="{{ siteLink.link }}" target="_blank">{{ siteLink.heading }}</a>
									</h4>
									<span class="sem-creative-card-roboto">{{ siteLink.description }}</span>
								</div>
							</div>
							<div class="sem-creative-card-location" *ngIf="creative?.location">
								<span
									><i class="fa fa-map-marker" aria-hidden="true" style="color: #575757"></i>
									{{ creative.location }}</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="creative.isAudioCreative && creative.audioURL" class="audioDisplayOuterBlock">
				<app-audio-player [audioURL]="creative.audioURL"></app-audio-player>
			</div>
		</div>
		<div class="clear"></div>
	</div>
	<div class="clear"></div>
</div>
